import Scene = Phaser.Scene;
import {ResourceType} from "@/store/place/types";
import ResourceUtils from "@/utils/resource-utils";
import {Player} from "@/store/player/types";
import TextUtils from "@/utils/text-utils";
import {Keys} from "@/constants/key";
import {Fonts} from "@/constants/font";
import Text = Phaser.GameObjects.Text;
import {ResourceContainer} from "@/scenes.ui/resource-container";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import TaskUtils from "@/utils/task-utils";

export class BottomPanel extends ResourceContainer {

    private static readonly ICON_SHIFT_Y = 0;

    private static readonly CELL_SIZE_X = 70;
    private static readonly CELL_SIZE_Y = 60;

    private static readonly ICON_SCALE = 0.7;

    private textByRes: Map<ResourceType, Text> = new Map();

    constructor(scene: Scene, x: number, y: number, player: Player) {
        super(scene);
        let self = this;

        this.scene = scene;
        this.x = 0;
        this.y = y;
        this.setOrigin(0,0);
        this.setDefaultDepth();

        const bottMenu = SpriteUtils.addImage(this.scene, 0, -50, Keys.UI_BOTTOM_MENU).setOrigin(0, 0);
        this.add(bottMenu);

        let resources: Map<ResourceType, number> = ResourceUtils.convertToBalance(player);

        let group = this.scene.add.group();

        let creaturesCount = player.creatures.length;
        let textShiftX = BottomPanel.getTextShiftX(creaturesCount);
        let textShiftY = BottomPanel.getTextShiftY(creaturesCount);

        for (let [key, value] of resources) {

            const resIcon = SpriteUtils.addImage(this.scene, 0, BottomPanel.ICON_SHIFT_Y, ResourceUtils.getResourceImageNoShadow(key), BottomPanel.ICON_SCALE, BottomPanel.ICON_SCALE);
            resIcon.setOrigin(0.5,0);

            const resText = TextUtils.addTextAdvanced(scene, BottomPanel.getValueText(key, value), textShiftX, textShiftY,
                '#fefefe', 13, 'normal', 80, 'left', 1, Fonts.MYRIADPRO_BOLD);
            resText.setStroke('#000000', 1);
            resText.setOrigin(0,0);

            let container = this.scene.add.container(0, 0, [resIcon, resText]);
            group.add(container);
            self.add(container);

            this.textByRes.set(key, resText);
        }

        Phaser.Actions.GridAlign(group.getChildren(), {
            cellWidth: BottomPanel.CELL_SIZE_X * CU.S,
            cellHeight: BottomPanel.CELL_SIZE_Y * CU.S,
            x: (70 - BottomPanel.CELL_SIZE_X / 2) * CU.S,
            y: (-10 - BottomPanel.CELL_SIZE_Y / 2) * CU.S
        });

        for (let obj of group.getChildren()) {
            this.add(obj);
        }
    }

    public setDefaultDepth() {
        this.setDepth(999);
    }

    public setTopDepth() {
        this.setDepth(4000);
    }

    public setBalance(player: Player) {
        let resources: Map<ResourceType, number> = ResourceUtils.convertToBalance(player);
        if (this.textByRes && resources) {
            for (let [key, value] of resources) {
                if (this.textByRes.get(key) && this.textByRes.get(key)!.active) {
                    this.textByRes.get(key)!.setText(BottomPanel.getValueText(key, value));
                }
            }
        }
    }

    private static getValueText(key: ResourceType, value: number) {
        return key === ResourceType.MITHRIL ? String(value) : TextUtils.formatMoney(value);
    }

    private static getTextShiftX(playerCreaturesCount: number) {
        if (playerCreaturesCount < 5) {
            return 5;
        } else {
            return -25;
        }
    }

    private static getTextShiftY(playerCreaturesCount: number) {
        if (playerCreaturesCount < 5) {
            return 15;
        } else {
            return 18;
        }
    }

    public setOrigin(x: number, y: number): void {
        // do nothing
    }
}
